/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BackAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function BackAction({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Actions/BackAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let imageCaptureQuestionIdValueData = fromData.useDataValue({ viewPath,
context: 'imageCaptureQuestion',
path: 'id',
})
let imageCaptureSelectedFlowQuestionsValueData = fromData.useDataValue({ viewPath,
context: 'imageCaptureSelected',
path: 'flowQuestions',
})
let imageCaptureQuestionHideBackValueData = fromData.useDataValue({ viewPath,
context: 'imageCaptureQuestion',
path: 'hideBack',
})
let aggregateData = fromHelpers.isContent(imageCaptureQuestionIdValueData, imageCaptureSelectedFlowQuestionsValueData, imageCaptureQuestionHideBackValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}